import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs, setupConfig
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';
import '@ionic/react/css/display.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/float-elements.css';
/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/typography.css';
import { archiveOutline, exitOutline, settingsOutline } from 'ionicons/icons';
import { useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Logon } from './pages/Logon';
import { PackageList } from './pages/packageList/PackageList';
import { TakePackage } from './pages/takePackage/TakePackage';
import { NewPackage } from './pages/newPackage/NewPackage';
import { PutPackage } from './pages/putPackage/PutPackage';
import { Settings } from './pages/settings/Settings';
/* Theme variables */
import './theme/variables.css';

const app: React.FC = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  setupConfig({mode: 'ios'});

  return (
    <IonApp>
      <IonReactRouter>
        <IonTabs>
          <IonRouterOutlet animated={loggedIn}>
            <Route exact path='/received-packages'>
              <PackageList type='received'/>
            </Route>
            <Route exact path='/sent-packages'>
              <PackageList type='sent'/>
            </Route>
            <Route path='/settings'>
              <Settings />
            </Route>
            <Route path='/logon'>
              <Logon setLoggedIn={loggedIn => setLoggedIn(loggedIn)} />
            </Route>
            <Route exact path='/received-packages/take-package/:packageId' component={TakePackage}/>
            <Route exact path='/sent-packages/new-shipment' component={NewPackage} />
            <Route exact path='/sent-packages/put-package/:packageId' component={PutPackage}/>
            <Route exact path="/">
              <Redirect to="/received-packages" />
            </Route>
          </IonRouterOutlet>
          <IonTabBar slot="bottom" hidden={!loggedIn}>
            <IonTabButton tab="tab1" href="/received-packages">
              <IonIcon icon={archiveOutline} />
              <IonLabel>Received packages</IonLabel>
            </IonTabButton>
            <IonTabButton tab="tab2" href="/sent-packages">
              <IonIcon icon={exitOutline} />
              <IonLabel>Send packages</IonLabel>
            </IonTabButton>
            <IonTabButton tab="tab3" href="/settings">
              <IonIcon icon={settingsOutline} />
              <IonLabel>Settings</IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      </IonReactRouter>
    </IonApp>
  );
};

export { app as App };
